export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "srVideoStream": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Live video stream"])}
      },
      "fr": {
        "srVideoStream": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transmission vidéo en direct"])}
      }
    }
  })
}
